export default __webpack_public_path__ + "static/media/blogcard6.d5b8418e.png";